// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"929365d7","223":"306e53e3","346":"d6430fbb","474":"09088238","652":"8061b969","847":"295e0687","953":"9dd2a95a","965":"427b9021"}[chunkId] + ".chunk.js";
};